<template>
  <div class="bodyImg">
    <div class="d-content">
      <div class="a-download clear">
        <div class="down-ietm windows">
          <div class="down-ietm-inner">
            <div class="logo-area">
              <div class="itemlogo"></div>
            </div>
            <div class="info-area">
              <div class="d-item-title">Windows版</div>
              <div class="d-item-desc">七色码画（公测版） </div>
              <div class="d-item-desc"><span class="update-time">基于scratch3.0开发</span></div>
              <div class="d-item-desc">版本3.1.0 <span class="update-time">2021-6-11发布</span></div>
              <div class="down-btn"><a href="http://www.jszsrobot.com/setup/v3.1.0.exe" onClick=""></a></div>
            </div>
          </div>
        </div>
        <div class="down-ietm windows">
          <div class="down-ietm-inner">
            <div class="logo-area">
              <div class="itemlogo"></div>
            </div>
            <div class="info-area">
              <div class="d-item-title">Windows版</div>
              <div class="d-item-desc"></div>
              <div class="d-item-desc"><span class="update-time">基于scratch2.0开发</span></div>
              <div class="d-item-desc">版本2.0.1 <span class="update-time">2020-5-1发布</span></div>
              <div class="d-item-desc">&nbsp</div>
              <div class="down-btn"><a href="http://www.jszsrobot.com/setup/Setup-x64.exe" onClick=""></a></div>
            </div>
          </div>
        </div>
        <div class="down-ietm android">
          <div class="down-ietm-inner">
            <div class="logo-area">
              <div class="itemlogo"></div>
            </div>
            <div class="info-area">
              <div class="d-item-title">Android版</div>
              <div class="d-item-desc"><span class="update-time">遥控程序</span></div>
              <div class="d-item-desc">版本2.1.5 <span class="update-time">2020-07-02</span></div>
              <div class="d-item-desc"> &nbsp</div>
              <div class="down-btn"><a href="http://www.jszsrobot.com/setup/newidea.apk" onClick=""></a></div>
            </div>

          </div>
        </div>
      </div>

    </div>
  </div>

</template>

<script>
  import $ from 'jquery'
  window.tcssReport = function(hottag, domain) { /*点击流上报*/
    if (typeof pgvSendClick == 'function') {
      pgvSendClick({
        virtualDomain: domain || "jszsrobot.com",
        hottag: hottag
      });
    }
  };
  tcssReport('tim.downloads.pv')
  // 不同下载hover效果
  $('.down-ietm').hover(function() {
    $(this).addClass('hover')
    $(this).find('.itemlogo').addClass('animation')
  }, function() {
    $(this).removeClass('hover')
    $(this).find('.itemlogo').removeClass('animation')
  })

  // function initFooter() {
  //   var footerTop = $('.footer').offset().top()
  //   var wh = $(window).height()
  //   var fh = $('.footer').height()
  //   if (footerTop < wh - fh) {
  //     $('.footer').addClass('fixed')
  //   }
  // }
  // initFooter()
    export default {
      name: "software",
      methods:{

      }
    }
</script>

<style scoped>
  @import "../../assets/css/download.css";
  @import "../../assets/css/public.css";

</style>



// WEBPACK FOOTER //
// src/components/software/software.vue